// TODO: Add Mixpanel events
export const AIImpact = () => {
  return (
    <div>
      <h1>AIImpact</h1>
    </div>
  );
};
